import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NbDialogService, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <nb-card class="dialog-card">
      <nb-card-header class="dialog-header">
        <h1 class="dialog-title">هل تريد تأكيد الحذف؟</h1>
      </nb-card-header>
      <nb-card-body class="dialog-footer mt-2 mb-3">
        <button nbButton fullWidth class="Button" size="small" (click)="onCancel()">الغاء</button>
        <button nbButton fullWidth status="danger" size="small" (click)="onConfirm()">تأكيد</button>
      </nb-card-body>
    </nb-card>
  `,
  styles: [
    `
      .dialog-card {
        width: 400px;
        margin: auto;
        text-align: center;
      }
      .dialog-header {
        background-color: #f7f9fc;
        border-bottom: 1px solid #e4e9f2;
      }
      .dialog-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0;
      }
      .dialog-body {
        padding: 1rem;
      }
      .dialog-message {
        font-size: 1rem;
        color: #6c757d;
      }
      .dialog-footer {
        display: flex;
        justify-content: space-around;
        padding: 0.5rem 1rem;
      }
    `,
  ],
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: NbDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
